import { Box, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Image from 'material-ui-image';

import { ReactComponent as LocationDefaultImage } from 'assets/images/location-default.svg';
import MessageBase, { MessageBaseProps } from 'components/MessageBase';

import MessageErrorFallback from './MessageErrorFallback';

type LocationMessageProps = MessageBaseProps;

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    minWidth: spacing(40),
  },
  image: {
    width: '100%',
    borderRadius: spacing(1),
  },
}));

export default function LocationMessage(props: LocationMessageProps) {
  const classes = useStyles();

  try {
    const {
      mensagem: {
        mensagemLocalizacao: { latitude, longitude, urlImagem },
      },
    } = props;
    const mapUrl = `https://maps.google.com/maps?q=${latitude},${longitude}&z=17&hl=pt-BR`;

    return (
      <MessageBase {...props}>
        <Link href={mapUrl} target="_blank" rel="no-referrer" color="inherit">
          <Box className={classes.root}>
            {urlImagem ? (
              <Image
                cover
                loading={false}
                src={urlImagem || ''}
                className={classes.image}
                style={{ backgroundColor: 'inherit' }}
              />
            ) : (
              <LocationDefaultImage width="100%" height="100%" />
            )}
          </Box>
        </Link>
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
